import ResultState from './ResultState'
export default ResultState
